import { useEffect } from "react";

const useDisableBody = (active: boolean) => {
  useEffect(() => {
    document.body.classList[active ? 'add' : 'remove']('disabled');
  }, [active])
}

export default useDisableBody;
